var map = {
	"./board/fascist_l.png": 252,
	"./board/fascist_m.png": 253,
	"./board/fascist_s.png": 254,
	"./board/liberal.png": 255,
	"./logo.svg": 256,
	"./membership/back.png": 63,
	"./membership/fascist.png": 64,
	"./membership/liberal.png": 65,
	"./misc/box.svg": 257,
	"./misc/dove.svg": 258,
	"./misc/fascist-victory.png": 259,
	"./misc/gun.svg": 260,
	"./misc/liberal-victory.png": 261,
	"./misc/skull.svg": 262,
	"./plaque/chancellor.png": 263,
	"./plaque/president.png": 264,
	"./policy/back.png": 66,
	"./policy/fascist.png": 67,
	"./policy/liberal.png": 68,
	"./role/back.png": 69,
	"./role/fascist0.png": 70,
	"./role/fascist1.png": 71,
	"./role/fascist2.png": 72,
	"./role/hitler0.png": 73,
	"./role/liberal0.png": 265,
	"./role/liberal1.png": 74,
	"./role/liberal2.png": 75,
	"./role/liberal3.png": 76,
	"./role/liberal4.png": 77,
	"./role/liberal5.png": 41,
	"./vote/back.png": 78,
	"./vote/ja.png": 79,
	"./vote/nein.png": 80
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 363;


//////////////////
// WEBPACK FOOTER
// ./src.common/assets \.(png|jpe?g|gif|svg)(\?.*)?$
// module id = 363
// module chunks = 0